import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import { Navigate, Link } from "react-router-dom";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Label,
  FormGroup,
  Button,
  Alert,
  Input,
} from "reactstrap";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "./Loader/Loader";
import config from "react-global-configuration";
import DatePicker from "react-datepicker";
import addDays from "date-fns/addDays";
import "react-datepicker/dist/react-datepicker.css";
import styles from "../pages/auth/register.module.css";
import { useTranslation } from "react-i18next";

const Self = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const [startDate, setStartDate] = useState(new Date());
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [takeBreak, setTakeBreak] = useState("");
  const [resMessage, setResMessage] = useState("");
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);

  useEffect(() => {
    loadRecordsTables();
    // Cleanup on unmount
    return () => {
      // Any cleanup if necessary
    };
  }, []);

  const loadRecordsTables = () => {
    setIsLoading(true);
    betSlipService
      .LimitDetails({ guid: user.guid })
      .then((res) => {
        const data = res[0];
        setIsLoading(false);
        setTakeBreak(data.take_break);
        // Update other state if necessary
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle error if necessary
      });
  };

  const handleValidSubmit = (event, values) => {
    swal({
      title: t("userProfile.selfExclusion.areYouSure"),
      text: t("userProfile.selfExclusion.actionCannotBeUndone"),
      // text: "Are you sure you want to Self Exclude.", {}
      icon: "warning",
      buttons: [
        t("userProfile.selfExclusion.buttons.cancel"),
        t("userProfile.selfExclusion.buttons.confirm"),
      ],
    }).then((confirm) => {
      if (confirm) {
        setIsLoading(true);

        let formData = new FormData();
        formData.append("take_break", values.take_break);
        formData.append("password", values.password);
        formData.append("guid", user.guid);
        formData.append("block_by", "user");
        formData.append("type", "Self Exclusion");

        betSlipService
          .updateLimit(formData, config)
          .then((res) => {
            if (res.success) {
              swal({
                title: "Success",
                text: res.message,
                icon: "success",
                buttons: t("userProfile.selfExclusion.buttons.ok"),
              }).then((result) => {
                if (result) {
                  window.location.href = "/logout";
                }
              });
            } else {
              swal({
                title: t("userProfile.selfExclusion.requiresAttention"),
                text: res.message,
                icon: "info",
                buttons: t("userProfile.selfExclusion.buttons.ok"),
              });
            }
          })
          .catch((error) => {
            setIsLoading(false);
            // Handle error if necessary
          });
      }
    });
  };

  const onDismiss = () => {
    setRight(false);
    setWrong(false);
  };

  const onTrigger = () => {
    props.parentCallback(true);
  };

  const defaultValues = {
    locationType: takeBreak,
  };

  const now = new Date();
  const year = now.getFullYear();
  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const hoursInYear = isLeapYear ? 8784 : 8760;
  const hoursIn6Months = hoursInYear / 2;
  const permanent = hoursInYear * 50;

  return (
    <React.Fragment>
      <div className="account-pages">
        <section className="dashboard-section padding-top padding-bottom">
          <Container>
            <Row>
              <Col className="col-lg-12">
                <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                  <h4 className="title m-0">Menu</h4>
                  <div className="user-toggler" onClick={onTrigger}>
                    <i className="las la-sliders-h"></i>
                  </div>
                </div>
                <div className="custom--card card--lg">
                  <div className="card--body">
                    <Row>
                      <div className="col-md-12">
                        <Alert color="success" isOpen={right}>
                          {resMessage}
                        </Alert>
                        <Alert color="danger" isOpen={wrong}>
                          {resMessage}
                        </Alert>
                      </div>
                    </Row>
                    <AvForm
                      onValidSubmit={handleValidSubmit}
                      model={defaultValues}
                    >
                      <Row className="gy-3">
                        <div className="col-md-12 text---black">
                          {t("userProfile.selfExclusion.note")}{" "}
                        </div>
                        <div className="col-md-5">
                          <div className="form-group">
                            <AvRadioGroup
                              label={t(
                                "userProfile.selfExclusion.selectPeriod",
                              )}
                              name="take_break"
                              required
                              errorMessage={t(
                                "userProfile.selfExclusion.pickOne",
                              )}
                            >
                              <AvRadio
                                label={t("userProfile.selfExclusion.sixMonths")}
                                value={hoursIn6Months}
                              />
                              <AvRadio
                                label={t("userProfile.selfExclusion.oneYear")}
                                value={hoursInYear}
                              />
                              <AvRadio
                                label={t("userProfile.selfExclusion.permanent")}
                                value={permanent}
                              />
                            </AvRadioGroup>
                          </div>
                        </div>
                      </Row>
                      <br />
                      <Row>
                        <div className="col-md-4 text---black">
                          {t("userProfile.selfExclusion.confirmPassword")}
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <AvField
                              id="password"
                              type="password"
                              className="form-control form--control style-two "
                              name="password"
                              placeholder={t(
                                "userProfile.selfExclusion.enterPassword",
                              )}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    "userProfile.selfExclusion.pleaseEnterPassword",
                                  ),
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 center">
                          <button className="cstm_btn2 active mt-3">
                            {t("userProfile.selfExclusion.update")}
                          </button>
                        </div>
                      </Row>
                    </AvForm>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};

export default connect(mapStateToProps)(Self);
